import React, { FC, useContext } from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { OperationDTO } from '@atlassiansox/phobos-client-ts';
import ReactJson from 'react-json-view';

import { Theme, ThemeContext } from '@/controllers/theme-controller';
import SfxIcon from '@/components/primitive/sfx-icon';
import {
  tableRowsStyles,
  tableRowsCozyPaddingStyles,
  tableHeadStyles,
  flexStart,
  spaceGapMinimum,
} from '@/styles';

import { tagStyles } from '../slo-panel/styles';

import { operationMemberRowStyles, queryStyles } from './styles';

type SLOCohortMembersProps = {
  operations: OperationDTO[];
};

const OperationMembers: FC<SLOCohortMembersProps> = ({ operations }) => {
  const [theme] = useContext(ThemeContext);

  return (
    <div>
      <div css={[tableHeadStyles, operationMemberRowStyles]}>
        <div>Type</div>
        <div>ID</div>
        <div>
          <div css={[flexStart, spaceGapMinimum]}>
            <SfxIcon />
            <span>Query</span>
          </div>
        </div>
      </div>
      <ul css={[tableRowsStyles, tableRowsCozyPaddingStyles]}>
        {operations.map((operation: OperationDTO) => {
          const { operationType, id, goodQuery, badQuery } = operation;

          const queries = {
            goodQuery,
            badQuery,
          };

          let appearance: ThemeAppearance = 'default';
          switch (operationType) {
            case 'CREATE':
              appearance = 'success';
              break;
            case 'UPDATE':
              appearance = 'moved';
              break;
            case 'REMOVE':
              appearance = 'removed';
              break;
          }

          return (
            <li key={id} css={[operationMemberRowStyles]}>
              <div>
                <Lozenge appearance={appearance}>{operationType}</Lozenge>
              </div>
              <div>
                <div css={tagStyles}>
                  <Lozenge>{id || '-'}</Lozenge>
                </div>
              </div>
              <div css={queryStyles}>
                <ReactJson
                  theme={theme === Theme.Dark ? 'google' : 'rjv-default'}
                  src={queries}
                  name={false}
                  displayObjectSize={false}
                  displayDataTypes={false}
                  enableClipboard={false}
                  iconStyle="square"
                  collapsed
                  style={{ background: 'inherit' }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default OperationMembers;
